import React from 'react';
import { DefaultTheme, useTheme } from 'styled-components';

import IconProps from './IconProps';

function LearningIcon(props: IconProps) {
	const theme = useTheme();

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="13" height="18" viewBox="0 0 13 18">
			<g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
				<g
					fill={theme.colors[props.color as keyof DefaultTheme['colors']]}
					fillRule="nonzero"
					transform="translate(-22 -129)"
				>
					<path d="M34.376 145.875V147H22v-1.125h5.625v-2.317c-3.15-.34-5.625-3.435-5.625-7.246 0-4.039 2.77-7.312 6.188-7.312 3.417 0 6.188 3.273 6.188 7.312 0 3.811-2.476 6.905-5.626 7.246v2.317h5.626zm-1.126-9.563c0-3.417-2.266-6.188-5.062-6.188-2.796 0-5.063 2.771-5.063 6.188 0 3.182 1.973 5.772 4.5 6.119v-3.585l-3.383-3.384.846-.846 2.537 2.538v-4.78h1.125v4.787l2.527-2.527.839.84-3.366 3.365v3.592c2.528-.347 4.5-2.937 4.5-6.119z" />
				</g>
			</g>
		</svg>
	);
}

export default React.memo(LearningIcon);
